import React from 'react';

import API from '../../REST/api';
import { MAINTENANCE } from './constants';
import NotificationModal from './NotificationModal';
import OutageReminder from './OutageReminder';
import OutageScreenSaver from './OutageScreenSaver';

const MINUTE = 60 * 1000;

export default class Announcements extends React.Component {
  state = { announcements: [], maintenanceMode: false };

  componentDidMount() {
    this.updateCurrentAnnouncement();
    this.callInterval = setInterval(
      () => this.updateCurrentAnnouncement(),
      5 * MINUTE,
    );
  }

  componentWillUnmount() {
    if (this.callInterval) clearInterval(this.callInterval);
  }

  async updateCurrentAnnouncement() {
    try {
      const announcements = await API.getAnnouncements({
        search: { upcoming: true },
      });
      this.setState({ announcements, maintenanceMode: false });
    } catch (e) {
      if (e.response?.status === 503) {
        this.setState({ maintenanceMode: true });
      }
    }
  }

  render() {
    const maintenanceAnnouncements = this.state.announcements.filter(
      announcement => announcement.type.includes(MAINTENANCE),
    );
    if (this.state.maintenanceMode) {
      return <OutageScreenSaver />;
    }
    return (
      <>
        <NotificationModal announcements={this.state.announcements} />;
        <OutageReminder announcements={maintenanceAnnouncements} />
      </>
    );
  }
}
